<template>
  <div>
    <div class="input-group">
      <label>NUMBER OF BRACKETS</label>
      <div v-if="errors.bracketPicksValue">{{errors.bracketPicksValue}}</div>
      <pinhigh-select
           :options="[2,3,4,5,6,7,8,9,10]"
           v-model="poolStyleConfigValue"
           ></pinhigh-select>
    </div>
    <div v-if="poolStyleConfigField && poolStyleConfigField.length">
      <div><a href="#" @click.prevent="resetPoolStyleConfigField" class="button boring inline small no-margin">Get the latest field</a></div>
      <div><a href="#" @click.prevent="customizeBrackets = !customizeBrackets">Customize brackets?</a></div>
      <div v-if="errors.bracketPicksField">{{errors.bracketPicksField}}</div>
      <div v-if="customizeBrackets">
        Move
        <pinhigh-select
            :options="poolStyleConfigFieldOptions"
            v-model="selectedMovePlayer"
            ></pinhigh-select>
        to
        <pinhigh-select
            :options="movableBrackets"
            v-model="selectedMoveBracket"
            :on-select="setSelectedMoveBracket"
            ></pinhigh-select>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex from 'vuex';

import api from '../../api';

export default {
  name: 'BracketPicks',
  props: {
    errors: Object
  },
  created() {
    if (this.isPoolNew) {
      this.resetPoolStyleConfigField();
    }
  },
  data() {
    return {
      rankedField: [],
      customizeBrackets: false,
      selectedMovePlayer: null,
      selectedMoveBracket: null
    };
  },
  computed: {
    ...Vuex.mapGetters('poolForm', ['pool', 'isPoolNew']),
    poolStyleConfigValue: {
      get(){ return this.pool.pool_style_config.value; },
      set(value){
        this.$store.dispatch('poolForm/setPoolStyleConfigValue', value);
        this.resetPoolStyleConfigField();
      }
    },
    poolStyleConfigField: {
      get(){ return this.pool.pool_style_config.field; },
      set(value){ this.$store.dispatch('poolForm/setPoolStyleConfigField', value); }
    },
    poolStyleConfigFieldOptions() {
      return this.poolStyleConfigField.map(({name,bracket}) => ({value: name, label: `${name} - Bracket ${bracket}`}));
    },
    movableBrackets() {
      if (this.selectedMovePlayer) {
        const currentBracket = this.poolStyleConfigField.find(({name}) => name === this.selectedMovePlayer).bracket;
        return Array.from({length: this.poolStyleConfigValue}, (value, key) => key + 1).filter(bracket => {
          return bracket !== currentBracket;
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    setSelectedMoveBracket() {
      const field = [...this.poolStyleConfigField],
            moveFromIndex = field.findIndex(({name}) => name === this.selectedMovePlayer),
            moveToIndex = field.findIndex(({bracket}) => bracket === parseInt(this.selectedMoveBracket)),
            removedPlayer = field.splice(moveFromIndex, 1)[0];
      removedPlayer.bracket = parseInt(this.selectedMoveBracket);
      field.splice(moveToIndex, 0, removedPlayer);
      this.poolStyleConfigField = field;
      this.selectedMovePlayer = null;
      this.selectedMoveBracket = null;
    },
    defaultField() {
      const cutoff = ({bracket, total}) => {
        return Math.ceil(1.25 + 0.75 * (5 * bracket / total) + 3.75 * Math.pow((5 * bracket / total), 2));
      };

      const cutoffPercentages = [...Array(parseInt(this.pool.pool_style_config.value || 1) - 1).keys()].reduce((memo,index) => {
        return [...memo, cutoff({bracket: index + 1, total: this.pool.pool_style_config.value})];
      }, []);

      return this.rankedField.map((name, index) => {
        const bracket = cutoffPercentages.find(bracket => index / this.rankedField.length * 100 < bracket);
        return {name, bracket: cutoffPercentages.indexOf(bracket) + 1 || this.pool.pool_style_config.value};
      });
    },
    resetPoolStyleConfigField() {
      api.TournamentField.show({params: {id: this.pool.tournament_id}}).then(response => {
        this.rankedField = response.field;
        this.$store.dispatch('poolForm/setPoolStyleConfigField', this.defaultField());
      });
    }
  }
};
</script>
